import styled from 'styled-components/macro';
import * as colors from 'src/styles/colors';
import { mobilePoint } from 'src/styles/globalStyle';
import { PrimaryColors } from 'src/types/globalTypes';

import Breadcrumb from 'src/components/layout/breadcrumb/Breadcrumb';
import PlaceImg from 'src/components/ui-kit/PlaceImg';
import DetailBanner from 'src/components/layout/banner/DetailBanner';
import ToTop from 'src/components/ui-kit/ToTop';
import { useStore } from 'src/hooks/useStore';

const ImgDiv = styled.div`
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  position: absolute;
  z-index: -1;
  @media (max-width: ${mobilePoint}) {
    display: none;
  }
`;
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 39px;
  height: max-content;
`;
const FunDiv = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 80%;
  justify-content: space-between;
  font-size: 14px;
  padding: 20px 0;
  color: ${colors.BlueGray_600};
`;
const InnerWrapper = styled.div`
  align-items: center;
  width: 80%;
  border-radius: 8px;
  margin-bottom: 3em;
  @media (max-width: ${mobilePoint}) {
    width: 95%;
    height: max-content;
    top: 14%;
    text-align: center;
  }
`;

const Form = styled.div`
  width: 100%;
  padding: 0 1.5em;

  @media (max-width: ${mobilePoint}) {
    width: 100%;
    height: fit-content;
  }
`;

// 案件明細頁面輸出
export const WrapperDetailInfo = styled.div`
  display: grid;
  gap: 8px;
`;
export const SubTitle = styled.div`
  font-family: NotoSansTC-Bold;
  font-size: 16px;
  color: ${colors.BlueGray_700};
  display: flex;
  align-items: center;
  margin-top: 1em;
`;
export const Table = styled.div<{ color: string }>`
  font-size: 15px;
  border-radius: 6px;
  border: 1px solid ${(prop) => prop.color};
  overflow: hidden;
  line-height: 1.5em;
  color: ${colors.BlueGray_600};
  // 調整表格格線
  div {
    border-bottom: 1px solid ${(prop) => prop.color};
    div {
      border-right: 1px solid ${(prop) => prop.color};
      border-bottom: none;
      :last-child {
        border-right: none;
      }
      // 只有兩個div時最後一格(=2nd)需右框線
      :nth-child(2) {
        border-right: 1px solid ${(prop) => prop.color};
      }
      // 再下去的div不須框線，故以none蓋掉底下div設定
      div {
        border-right: none;
        :nth-child(2) {
          border-right: none;
        }
      }
    }
  }
  div:last-child {
    border-bottom: none;
  }

  @media (max-width: ${mobilePoint}) {
    div {
      border-bottom: none;
      div {
        border-right: 1px solid ${(prop) => prop.color};
        border-bottom: 1px solid ${(prop) => prop.color};
        :last-child {
          border-bottom: 1px solid ${(prop) => prop.color};
        }
        // 再下去的div不須框線，故以none蓋掉底下div設定
        div {
          border-right: none;
          border-bottom: none;
          :last-child {
            border-bottom: none;
          }
          :nth-child(2) {
            border-right: none;
          }
        }
      }
      div:nth-child(2n) {
        border-right: none;
      }
    }
    div:last-child {
      div:last-child {
        border-bottom: none;
      }
      div:nth-last-child(2) {
        border-bottom: none;
      }
    }
  }
`;
export const TopItem = styled.div`
  display: grid;
  grid-template-columns: 1fr 5fr;
  min-height: 38px;
  div:last-child {
    border-right: none !important;
  }
  @media (max-width: ${mobilePoint}) {
    grid-template-columns: 2fr 3fr;
  }
`;
export const Item = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr 1fr 2fr;
  min-height: 38px;

  @media (max-width: ${mobilePoint}) {
    grid-template-columns: 2fr 3fr;
  }
`;
export const Title = styled.div`
  display: flex;
  align-items: center;
  padding: 8px;
  text-align: left;
`;
export const Content = styled.div`
  display: flex;
  align-items: center;
  padding: 8px;
  background-color: ${colors.white};
  gap: 10px;
  text-align: left;
  word-break: break-word;
  @media (max-width: ${mobilePoint}) {
    display: block;
  }
`;
export const TagDiv = styled.div`
  width: 100%;
`;
export const ButtonA = styled.a<{ color: string }>`
  background-color: transparent;
  border: 1px solid ${(prop) => prop.color};
  border-radius: 7px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  padding: 8px 13px;
  @media (max-width: ${mobilePoint}) {
    line-height: 3em;
  }
`;
export const LinkDiv = styled.a<{ color?: string }>`
  color: ${(prop) => prop.color};
`;
export const NoContent = styled.div`
  color: ${colors.BlueGray_200};
`;
export const Annotation = styled.div`
  color: ${colors.BlueGray_400};
`;
export const SearchLink = styled.div<{ color?: string }>`
  color: ${(prop) => prop.color};
  cursor: pointer;
`;
export const QrCodeImg = styled.img<{ color?: string }>`
  height: 15em;
`;

interface Iprops {
  title: string;
  children: React.ReactNode;
  bannerBgImg: string;
  image: string;
  imgDot: string;
  bgColor: PrimaryColors;
  onClikcReturnPage: () => void;
  tip?: React.ReactNode;
}

/**
 * 案件明細頁面元件
 */
const DetailPage: React.FC<Iprops> = ({
  title,
  children,
  bannerBgImg,
  bgColor,
  image,
  imgDot,
  onClikcReturnPage,
}) => {
  const isMobile = useStore((state) => state.isMobile);
  const returnPageName = '搜尋結果';
  const subtitle = '案件明細';

  return (
    <>
      {isMobile && <ToTop />}
      {!isMobile && (
        <ImgDiv>
          <PlaceImg image={imgDot} placeProps={{ height: '80px', top: '20%', right: '0%' }} />
          <PlaceImg image={imgDot} placeProps={{ height: '80px', top: '40%', left: '0%' }} />
        </ImgDiv>
      )}
      <Wrapper>
        <DetailBanner
          title={title}
          bgImg={bannerBgImg}
          image={image}
          bgColor={bgColor.sixth}
          subtitle={subtitle}
        />
        <FunDiv>
          <Breadcrumb returnPageName={returnPageName} onClikcReturnPage={onClikcReturnPage} />
        </FunDiv>
        <InnerWrapper>
          <Form>{children}</Form>
        </InnerWrapper>
      </Wrapper>
    </>
  );
};

export default DetailPage;
